import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconSafeSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSafeSimple"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M2.5 7.5H4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 16.5H4.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="12.25" cy="12" r="3" stroke="currentColor"/><Path d="M9.96429 9.71429L8.25 8M14.5357 9.71429L16.25 8M14.5357 14.2857L16.25 16M9.96429 14.2857L8.25 16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSafeSimple;
